// extracted by mini-css-extract-plugin
export var centerItem = "FormWrapper-module--center-item--10Hiw";
export var error = "FormWrapper-module--error--2wLJ2";
export var middle = "FormWrapper-module--middle--2u1Il";
export var formContainer = "FormWrapper-module--form-container--32-1W";
export var button = "FormWrapper-module--button--oAAs9";
export var overlay = "FormWrapper-module--overlay--3kiEX";
export var showOverlay = "FormWrapper-module--show-overlay--2Wa71 FormWrapper-module--overlay--3kiEX";
export var loaderWrap = "FormWrapper-module--loader-wrap--1m7Mw";
export var spinner = "FormWrapper-module--spinner--2-BGM";
export var rotate = "FormWrapper-module--rotate--2U9vE";
export var midSuccess = "FormWrapper-module--mid-success--1T0Ma";
export var formWrap = "FormWrapper-module--form-wrap--1NI7A";
export var span1 = "FormWrapper-module--span1--2nF6X";